import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';
import { LP_URL, WHATSAPP_URL } from '../../lib/utils';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_hub-medico-apex/artifacts/zsn6307r_Logotipo%20com%20tag.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1e4e7e] text-white" data-testid="footer">
      <div className="container-apex py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="Apex Medical Hub"
              className="h-14 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Soluções estratégicas para empresas médicas. Organizamos sua operação financeira, tributária e gerencial para que você foque no que importa: seus pacientes.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Navegação</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-white/70 hover:text-white transition-colors text-sm">
                  Sobre a Apex
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-white/70 hover:text-white transition-colors text-sm">
                  Serviços
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/70 hover:text-white transition-colors text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-white/70 hover:text-white transition-colors text-sm">
                  Contato
                </Link>
              </li>
            </ul>
            <h4 className="font-heading font-semibold text-lg mb-4 mt-8">Ferramentas</h4>
            <ul className="space-y-3" data-testid="footer-ferramentas">
              <li>
                <Link to="/?calculadora=1" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-tool-calculadora-impostos">
                  Calculadora de impostos
                </Link>
              </li>
              <li>
                <Link to="/calculadora-plantao" className="text-white/70 hover:text-white transition-colors text-sm" data-testid="footer-tool-calculadora-plantao">
                  Quanto vale o seu plantão
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Serviços</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/servicos#contabilidade" className="text-white/70 hover:text-white transition-colors text-sm">
                  Contabilidade Tributária
                </Link>
              </li>
              <li>
                <Link to="/servicos#bpo-financeiro" className="text-white/70 hover:text-white transition-colors text-sm">
                  BPO Financeiro
                </Link>
              </li>
              <li>
                <Link to="/servicos#faturamento" className="text-white/70 hover:text-white transition-colors text-sm">
                  Faturamento
                </Link>
              </li>
              <li>
                <Link to="/servicos#gestao" className="text-white/70 hover:text-white transition-colors text-sm">
                  Gestão Completa
                </Link>
              </li>
              <li>
                <Link to="/servicos#analytics" className="text-white/70 hover:text-white transition-colors text-sm">
                  Business Analytics
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-white/70 text-sm">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span>Sediados em Boa Vista/RR<br />Atendemos clínicas em todo o Brasil</span>
              </li>
              <li>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors text-sm"
                >
                  <Phone size={18} />
                  <span>(95) 99154-8020</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato@apexmedicalhub.com"
                  className="flex items-center gap-3 text-white/70 hover:text-white transition-colors text-sm"
                >
                  <Mail size={18} />
                  <span>contato@apexmedicalhub.com</span>
                </a>
              </li>
            </ul>

            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.instagram.com/apexmedicalhub/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram-link"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {currentYear} Apex Medical Hub. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/privacidade" className="text-white/60 hover:text-white transition-colors">
              Política de Privacidade
            </Link>
            <Link to="/termos" className="text-white/60 hover:text-white transition-colors">
              Termos de Uso
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
